import request from "@utils/request";

/**
 * @author FJJ
 * @version 1.0
 * @Time 2022.05.26
 *
 **/
const SearchApiService = {
    /**
     * 采购商生成分销商账号
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=157#7061
     * @param data
     */
    AddFxAccount(data={}) {
        return request({
            url:  '/service/mg/distributor/create-fx-account',
            method: "POST",
            data
        });
    },
    /**
     * 翻译
     * @param data
     */
    getTranslate(data={}) {
        return request({
            // url:  '/service/tool/translate/translate',
            url:  '/service/tool/translate/do-translate',
            method: "POST",
            data
        });
    },
    /**
     * 跟进备注列表
     * @param data
     */
    getRemarkList(data={}) {
        return request({
            url:  '/service/mg/follower/query-remark-list',
            method: "POST",
            data
        });
    },
    /**
     * 跟进备注列表
     * @param data
     */
    postAction(sUrl,data={}) {
        return request({
            url:  sUrl,
            method: "POST",
            data
        });
    },
    /**
     * put请求
     * @param data
     */
    putAction(sUrl,data={}) {
        return request({
            url:  sUrl,
            method: "PUT",
            data
        });
    }
};

export default SearchApiService;
